module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_54.8a6c362f.mp3";